angular.module 'zc.masterApi'

.factory 'MasterInvoiceAdjustment', ($q, Api) ->
  class MasterInvoiceAdjustment
    @all: ->
      Api.get '/api/master/invoice_adjustments'
      .then (res) ->
        if res.data.success
          res.data.invoice_adjustments
        else
          $q.reject res

    @update: (adjustment_id, params) ->
      Api.patch "/api/master/invoice_adjustments/#{adjustment_id}", params, cache: false
      .then (res) ->
        if res.data.success
          res.data.invoice_adjustments
        else
          $q.reject res

    @destroy: (adjustment_id, params) ->
      Api.delete "/api/master/invoice_adjustments/#{adjustment_id}", params, cache: false
      .then (res) ->
        if res.data.success
          res.data.invoice_adjustment
        else
          $q.reject res



// WEBPACK FOOTER //
// ./src/master_admin_modules/master_api/api/invoice_adjustments.service.js.coffee